import DashboardLayout from "#/components/ui/DashboardLayout";
import ClientDetailPage from "#/pages/ClientDetail";
import ClientsPage from "#/pages/clients";
import DashboardPage from "#/pages/Dashboard";
import DeviceDetailPage from "#/pages/DeviceDetail";
import DevicesPage from "#/pages/devices";
import ItemDetailPage from "#/pages/itemdetail";
import ItemsPage from "#/pages/items";
import LoginPage from "#/pages/login";
import ProductDetailPage from "#/pages/productdetail";
import ProductsPage from "#/pages/products";
import RegisterPage from "#/pages/Register";
import RfidTagsPage from "#/pages/rfidtags";
import ShipmentLogDetailPage from "#/pages/shipmentlogdetail";
import ShipmentLogsPage from "#/pages/SiteDetail/shipmentlogs";
import SiteDetailPage from "#/pages/SiteDetail";
import SitesPage from "#/pages/sites";
import TemplateDetailPage from "#/pages/templatedetail";
import TemplatesPage from "#/pages/templates";
import TicketsPage from "#/pages/ticketmanagement";
import ClientMismatchPage from "#/pages/ClientMismatch";
import UnauthorizedPage from "#/pages/Unauthorized";
import VehicleDetailPage from "#/pages/vehicledetail";
import VehicleModelDetailPage from "#/pages/vehiclemodeldetail";
import VehicleModelsPage from "#/pages/vehiclemodels";
import VehiclesPage from "#/pages/vehicles";
import VerifyEmailPage from "#/pages/VerifyEmail";
import { Route, Routes, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { useAuth } from "#/hook/useAuth";
import { UserRole } from "#/types/user";
import { getFirstAllowedRoute } from "#/utils/routeUtils";

function IndexRedirect() {
  const { user } = useAuth();

  if (user?.role === UserRole.ADMIN) {
    return <Navigate to="/clients" replace />;
  }

  const redirectTo = getFirstAllowedRoute(user?.client?.allowedRoutes);
  return <Navigate to={redirectTo} replace />;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify" element={<VerifyEmailPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route path="/client-mismatch" element={<ClientMismatchPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<IndexRedirect />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="clients/:id" element={<ClientDetailPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="sites" element={<SitesPage />} />
        <Route path="sites/:id" element={<SiteDetailPage />} />
        <Route path="devices" element={<DevicesPage />} />
        <Route path="devices/:id" element={<DeviceDetailPage />} />
        <Route path="ticket-management" element={<TicketsPage />} />
        <Route path="inventory/items" element={<ItemsPage />} />
        <Route path="inventory/items/:id" element={<ItemDetailPage />} />
        <Route path="inventory/categories" element={<ProductsPage />} />
        <Route path="inventory/categories/:id" element={<ProductDetailPage />} />
        <Route path="inventory/templates" element={<TemplatesPage />} />
        <Route path="inventory/templates/:id" element={<TemplateDetailPage />} />

        <Route path="fleet/models" element={<VehicleModelsPage />} />
        <Route path="fleet/models/:id" element={<VehicleModelDetailPage />} />
        <Route path="fleet/vehicles" element={<VehiclesPage />} />
        <Route path="fleet/vehicles/:id" element={<VehicleDetailPage />} />
        <Route path="fleet/logs" element={<ShipmentLogsPage />} />
        <Route path="fleet/logs/:id" element={<ShipmentLogDetailPage />} />

        <Route path="rfid-tags" element={<RfidTagsPage />} />
      </Route>
    </Routes>
  );
}
